import 'babel-polyfill'
import Vue from 'vue'
import promise from 'es6-promise'
promise.polyfill()

// 弹出新窗口页面（token要存localstorage）
// let routeData = this.$router.resolve({ path: '/main/bookDetails', query: {  code: row.code,name:row.name,type:type } });
// window.open(routeData.href, '_blank');

import App from './App'
import "animate.css" //动画
import Navigation from 'vue-navigation' //前进刷新，后退不刷新依赖,类似于keep-alive
Vue.use(Navigation, {
  router
}) // 前后顺序不能颠倒，否则会报错

import router from './router'

import vuescroll from 'vuescroll/dist/vuescroll-native';
// 你可以在这里设置全局配置
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native',
    },
    scrollPanel: {
      scrollingX: false,
      scrollingY: true
    },
    rail: {
      size:"1px"
    },
    bar: {
      background: '#ccc',
      keepShow:true,
      size:"11px"
    }
  }, // 在这里设置全局默认配置
  name: 'customScroll' // 在这里自定义组件名字，默认是vueScroll
});

// 公共组件
import vFooter from "./view/common/footer.vue"
import vFooter2 from "./view/common/footer2.vue"
import companyLogoCommon from "./view/common/companyLogoCommon.vue"
Vue.component("companyLogoCommon",companyLogoCommon)
Vue.component("vFooter",vFooter)
Vue.component("vFooter2",vFooter2)

// element ui
import ElementUI,{ Message }  from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 时间转换器
import moment from 'moment';
Vue.prototype.moment = moment;

// Vue.prototype.$wsUrl = "ws://192.168.0.123:9092/ws/0/"; // websocket地址
Vue.prototype.$wsUrl = 'wss://job-im.gogowork.cn/ws/0/'; // websocket地址

// Vue.prototype.$Static = "http://192.168.0.131:8080/img"; // 图片路径
Vue.prototype.$Static = "https://img.gogowork.cn/static/img"; // 图片路径
Vue.prototype.$Static2 = "https://img.gogowork.cn/static"; // 图片路径

// Vue.prototype.$configUrl = "https://job.gogowork.cn"; // 接口域名(h5、外链使用)
Vue.prototype.$configUrl = "https://job.gogowork.cn"; // 接口域名(h5、外链使用)

// rem布局
import "../static/rem.js"

Vue.prototype.Event = new Vue(); // 同级之间组件传值
// 错误弹框
Vue.prototype.$error = ((err)=>{
  Message({
    type:"error",
    message:"网络请求异常",
    duration:2000
  })
})
// 百度统计
router.beforeEach((to, from, next) => {
  setTimeout(() => {
     window._hmt = _hmt; // 修改为window 全局变量
      var _hmt = _hmt || [];
      (function () {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?eb1e5b824081f2d4ef2cf01d81998a81";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }, 0);
    next();
  })

// 通过type获取字典列表
Vue.prototype.getFilterList = (type)=>{
  if(localStorage.getItem("dictList")){
     return JSON.parse(localStorage.getItem("dictList")).filter(item=>item.type==type)
  }else{
    return []
  }
}

// 城市json
import region from "../static/region.json"
Vue.prototype.$region = region.data;

// 表情json
import emojilist from "../static/emojilist.json"
Vue.prototype.$emojilist = emojilist.emojiList;

// websocket
import socketApi from "../static/socket.js";//找到封装的socket.js文件
Vue.prototype.$socketApi = socketApi

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App), //引用element ui的时候用的
  template: '<App/>',
  components: {
    App,
  }
})



// WEBPACK FOOTER //
// ./src/main.js